import { rei } from "@/services/api"

class caixaService {
    static abrirCaixa (saldoAnterior) {
        return rei.post('caixa-abrir', saldoAnterior)
          .then(res => res.data)
    }

    static caixaAtual (data) {
        return rei.get(`caixa-atual/${data}`)
          .then(res => res.data)
    }

    static caixaAnterior () {
      return rei.get(`caixa-anterior`)
        .then(res => res.data)
    }

    static fecharCaixa (payload) {
      return rei.post('caixa-fechar', payload)
      .then(res => res.data)
    }

    static reabrirCaixa (data) {
      return rei.post('caixa-reabrir', {data})
      .then(res => res.data)
    }
}

export default caixaService